module.exports = __webpack_public_path__ + "images/zeeuwsea59f89e3d792546540b328e0eeb3a3e4.png";